<template>
  <div>
    <v-card outlined>
      <v-card-title>Empleados por categorias</v-card-title>
      <v-row>        
        <v-col cols="12">
          <GChart type="PieChart" :data="chartData" :options="chartOptions" />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  components: {
    GChart,
  },

  mounted() {
    this.process();
  },

  data() {
    return {
      loadingChart: true,
      chartData: [["Categorias", "Empleados"]],

      chartOptions: {
        chart: {
          title: "Empleados por categorias",
          subtitle: "",
        },
        pieHole: 0.4,
      },
    };
  },


  methods: {
    process() {
      this.loadingChart = true;
      this.chartData = [["Categoria", "Empleados"]];

      setTimeout(() => {
        this.$store.dispatch("countByCategory").then((res) => {
          let itemChart = [];

          res.forEach(element => {
            itemChart = [`${element.name} (${element.count})`, element.count];
            this.chartData.push(itemChart);
          });

          this.loadingChart = false;

        })
      }, 500);
    },
  },
};
</script>

<style></style>
